export const trimToMaxLength = (
  str: string | undefined,
  maxLength: number
): string => {
  if (!str) {
    return '';
  }
  if (str.length > maxLength) {
    return str.slice(0, maxLength) + '...';
  }
  return str;
};
